require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interview-mark-cutajar-norti-vikings.json") })
        }
      }, "path---interview-mark-cutajar-norti-vikings");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interview-mark-cutajar-norti-vikings!./.cache/json/interview-mark-cutajar-norti-vikings.json
// module id = 691
// module chunks = 231608221292675